import React from 'react';
import { ArrowRight, CheckCircle } from 'lucide-react';

const CTASection: React.FC = () => {
  const benefits = [
    "Download automático de XMLs das Secretarias",
    "Organização inteligente de documentos",
    "Validação em tempo real de notas fiscais",
    "Integração via API REST documentada"
  ];

  return (
    <section className="py-20 bg-[#103541] text-white">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-3xl md:text-4xl font-bold mb-6">
              Automatize a gestão de notas fiscais
            </h2>
            <p className="text-lg text-gray-300 mb-8">
              Junte-se a milhares de empresas que já simplificaram sua gestão fiscal
              com a plataforma mais completa do mercado.
            </p>
            
            <div className="space-y-4 mb-8">
              {benefits.map((benefit, index) => (
                <div key={index} className="flex items-center gap-3">
                  <CheckCircle className="text-[#7AEA53]" size={20} />
                  <span>{benefit}</span>
                </div>
              ))}
            </div>

            <button 
              className="bg-[#7AEA53] text-white px-8 py-4 rounded-xl hover:bg-[#6DD142] transition-all transform hover:-translate-y-1 flex items-center gap-2 text-lg font-semibold"
              onClick={() => window.location.href = 'https://app.nfe.io'}
            >
              Começar gratuitamente
              <ArrowRight size={20} />
            </button>
          </div>

          <div className="bg-white/10 rounded-2xl p-8">
            <div className="text-2xl font-bold mb-2">
              "Economizamos mais de 30 horas por semana na gestão de notas"
            </div>
            <p className="text-gray-300 mb-6">
              A automatização do download e organização dos XMLs eliminou tarefas
              manuais e nos permitiu focar no que realmente importa.
            </p>
            <div className="flex items-center gap-4">
              <img 
                src="https://images.pexels.com/photos/2381069/pexels-photo-2381069.jpeg"
                alt="Foto do cliente"
                className="w-12 h-12 rounded-full object-cover"
              />
              <div>
                <div className="font-semibold">Roberto Santos</div>
                <div className="text-sm text-gray-300">Diretor Financeiro, TechCorp</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;